export default "__VITE_ASSET__DVhkC6Rl__"